import React from "react";

export default function Privacy() {
  return (
    <div
      className="min-h-screen bg-black text-white"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div
        className="max-w-3xl mx-auto px-6"
        style={{
          paddingTop: "clamp(80px, 12vw, 200px)",
          paddingBottom: "120px",
        }}
      >
        <h1
          style={{
            fontFamily: "Archivo, sans-serif",
            fontVariationSettings: '"wght" 600, "wdth" 75',
            fontSize: "clamp(48px, 8vw, 96px)",
            letterSpacing: "-0.02em",
            lineHeight: "0.9",
            marginBottom: "80px",
            textTransform: "uppercase",
          }}
        >
          PRIVACY<br />POLICY
        </h1>

        <div style={{ fontSize: "16px", lineHeight: "1.8", color: "#a1a1aa" }}>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              1. General Information
            </h2>
            <p>
              The protection of your personal data is very important to us. This privacy policy explains what data we collect and how it is used when you visit this website. Personal data refers to any information that can be used to personally identify you.
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              2. Responsible Party
            </h2>
            <p>
              René Gebhardt<br />
              Weserstr. 75<br />
              12059 Berlin<br />
              Germany<br />
              Email: mail@rene-gebhardt.com
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              3. Hosting
            </h2>
            <p>This website is hosted by:</p>
            <p style={{ marginTop: "16px" }}>
              Vercel Inc.<br />
              340 S Lemon Ave #4133<br />
              Walnut, CA 91789<br />
              USA
            </p>
            <p style={{ marginTop: "16px" }}>
              When you visit this website, Vercel may automatically collect technical information such as IP address, browser type and version, operating system, referrer URL, and date and time of access. These data are used to ensure the secure and reliable operation of the website.
            </p>
            <p style={{ marginTop: "16px" }}>
              Legal basis: Art. 6(1)(f) GDPR (legitimate interest).<br />
              More information:{" "}
              <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "underline" }}>
                vercel.com/legal/privacy-policy
              </a>
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              4. Domain Registration
            </h2>
            <p>The domain is registered through:</p>
            <p style={{ marginTop: "16px" }}>
              IONOS SE<br />
              Elgendorfer Str. 57<br />
              56410 Montabaur<br />
              Germany
            </p>
            <p style={{ marginTop: "16px" }}>
              IONOS may process technical data such as IP addresses to provide domain services.<br />
              More information:{" "}
              <a href="https://www.ionos.com/terms-gtc/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "underline" }}>
                ionos.com/terms-gtc/privacy-policy
              </a>
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              5. Contact Form
            </h2>
            <p>
              If you use the contact form on this website, the information you provide (name, email address, message) will be processed for the purpose of responding to your request.
            </p>
            <p style={{ marginTop: "16px" }}>The form is implemented using the service EmailJS.</p>
            <p style={{ marginTop: "16px" }}>
              EmailJS Pte. Ltd.<br />
              20 Cecil Street<br />
              Singapore
            </p>
            <p style={{ marginTop: "16px" }}>
              EmailJS processes the submitted form data in order to deliver the message to the website operator.
            </p>
            <p style={{ marginTop: "16px" }}>
              Legal basis: Art. 6(1)(b) GDPR (processing necessary for pre-contractual communication).<br />
              More information:{" "}
              <a href="https://www.emailjs.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "underline" }}>
                emailjs.com/legal/privacy-policy
              </a>
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              6. Email Communication
            </h2>
            <p>
              Messages sent via the contact form are forwarded to an email inbox hosted by Google (Gmail).
            </p>
            <p style={{ marginTop: "16px" }}>
              Google Ireland Limited<br />
              Gordon House<br />
              Barrow Street<br />
              Dublin 4, Ireland
            </p>
            <p style={{ marginTop: "16px" }}>
              When you send a message, your data may be stored on Google's servers for the purpose of processing your request.<br />
              More information:{" "}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "underline" }}>
                policies.google.com/privacy
              </a>
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              7. Fonts
            </h2>
            <p>
              This website uses fonts (Archivo, Inter) that are hosted locally on the server. No connection to external font servers is established when visiting this website and no personal data is transmitted to third parties.
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              8. Server Log Files
            </h2>
            <p>
              The hosting provider automatically collects and stores information in server log files, including browser type and version, operating system, referrer URL, hostname, time of request, and IP address. These data are not combined with other data sources.
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              9. Your Rights under the GDPR
            </h2>
            <p>You have the right to:</p>
            <p style={{ marginTop: "16px" }}>
              Request access to your stored data (Art. 15 GDPR)<br />
              Correction of inaccurate data (Art. 16 GDPR)<br />
              Deletion of your data (Art. 17 GDPR)<br />
              Restriction of processing (Art. 18 GDPR)<br />
              Data portability (Art. 20 GDPR)<br />
              Lodge a complaint with a supervisory authority
            </p>
          </section>

          <section>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              10. Changes to this Privacy Policy
            </h2>
            <p>
              We reserve the right to update this privacy policy to ensure it complies with current legal requirements or changes to this website.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}